import {
  CREATEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM,
  GETOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM,
  UPDATEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM,
  DELETEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM,
  CREATEOPDOUTDENTALASSOCIATEDSYMPTOM,
  GETOPDOUTDENTALASSOCIATEDSYMPTOM,
  UPDATEOPDOUTDENTALASSOCIATEDSYMPTOM,
  DELETEOPDOUTDENTALASSOCIATEDSYMPTOM,
  CREATEOPDOUTDENTALPRESENTILLNESSHISTORY,
  GETOPDOUTDENTALPRESENTILLNESSHISTORY,
  UPDATEOPDOUTDENTALPRESENTILLNESSHISTORY,
  DELETEOPDOUTDENTALPRESENTILLNESSHISTORY,
  GETDENTALCHILDHOODILLNESSES,
  CREATEDENTALCHILDHOODILLNESSES,
  DELETEDENTALCHILDHOODILLNESSES,
  UPDATEDENTALCHILDHOODILLNESSES,
  GETDENTALADULTILLNESSES,
  CREATEDENTALADULTILLNESSES,
  DELETEDENTALADULTILLNESSES,
  UPDATEDENTALADULTILLNESSES,
  GETDENTALHEALTHMAINTENANCE,
  CREATEDENTALHEALTHMAINTENANCE,
  DELETEDENTALHEALTHMAINTENANCE,
  UPDATEDENTALHEALTHMAINTENANCE,
  GETDENTALSYMPTOMS,
  CREATEDENTALSYMPTOMS,
  DELETEDENTALSYMPTOMS,
  UPDATEDENTALSYMPTOMS,
  GETDENTALCOMORBIDITY,
  CREATEDENTALCOMORBIDITY,
  DELETEDENTALCOMORBIDITY,
  UPDATEDENTALCOMORBIDITY,
  GETDENTALPERSONALHISTORY,
  CREATEDENTALPERSONALHISTORY,
  DELETEDENTALPERSONALHISTORY,
  UPDATEDENTALPERSONALHISTORY,
  GETDENTALOCCUPATIONALHISTORY,
  CREATEDENTALOCCUPATIONALHISTORY,
  DELETEDENTALOCCUPATIONALHISTORY,
  UPDATEDENTALOCCUPATIONALHISTORY,
  GETDENTALPSYCHOLOGICAL,
  CREATEDENTALPSYCHOLOGICAL,
  DELETEDENTALPSYCHOLOGICAL,
  UPDATEDENTALPSYCHOLOGICAL,
  GETDENTALGYNECOLOGICAL,
  CREATEDENTALGYNECOLOGICAL,
  DELETEDENTALGYNECOLOGICAL,
  UPDATEDENTALGYNECOLOGICAL,
  GETDENTALOBSTETRICAL,
  CREATEDENTALOBSTETRICAL,
  DELETEDENTALOBSTETRICAL,
  UPDATEDENTALOBSTETRICAL,
  GETGENERALOPDOBSTETRICALHISTORY,
  CREATEGENERALOPDOBSTETRICALHISTORY,
  UPDATEGENERALOPDOBSTETRICALHISTORY,
  DELETEGENERALOPDOBSTETRICALHISTORY,
  GETGENERALCOMPLAINTPASTILLNESSNOTE,
  CREATEGENERALCOMPLAINTPASTILLNESSNOTE,
  DELETEGENERALCOMPLAINTPASTILLNESSNOTE,
  UPDATEGENERALCOMPLAINTPASTILLNESSNOTE,
  GETDENTALCOMPLAINTFAMILYRELATION,
  CREATEDENTALCOMPLAINTFAMILYRELATION,
  UPDATEDENTALCOMPLAINTFAMILYRELATION,
  DELETEDENTALCOMPLAINTFAMILYRELATION,
  GETDENTALOPDOUTPERSONALDIETHIST,
  CREATEDENTALOPDOUTPERSONALDIETHIST,
  UPDATEDENTALOPDOUTPERSONALDIETHIST,
  DELETEDENTALOPDOUTPERSONALDIETHIST,
  GETDENTALOPDOUTPERSONALAPPETITEHIST,
  CREATEDENTALOPDOUTPERSONALAPPETITEHIST,
  UPDATEDENTALOPDOUTPERSONALAPPETITEHIST,
  DELETEDENTALOPDOUTPERSONALAPPETITEHIST,
  GETDENTALOPDOUTPERSONALDIGESTIVETRACTHIST,
  CREATEDENTALOPDOUTPERSONALDIGESTIVETRACTHIST,
  UPDATEDENTALOPDOUTPERSONALDIGESTIVETRACTHIST,
  DELETEDENTALOPDOUTPERSONALDIGESTIVETRACTHIST,
  GETDENTALOPDOUTPERSONALBOWELHIST,
  CREATEDENTALOPDOUTPERSONALBOWELHIST,
  UPDATEDENTALOPDOUTPERSONALBOWELHIST,
  DELETEDENTALOPDOUTPERSONALBOWELHIST,
  GETDENTALOPDOUTPERSONALSLEEPHIST,
  CREATEDENTALOPDOUTPERSONALSLEEPHIST,
  UPDATEDENTALOPDOUTPERSONALSLEEPHIST,
  DELETEDENTALOPDOUTPERSONALSLEEPHIST,
  GETDENTALOPDOUTPERSONALADDICTIONS,
  CREATEDENTALOPDOUTPERSONALADDICTIONS,
  UPDATEDENTALOPDOUTPERSONALADDICTIONS,
  DELETEDENTALOPDOUTPERSONALADDICTIONS,
  GETDENTALOPDOUTPERSONALHIGHRISK,
  CREATEDENTALOPDOUTPERSONALHIGHRISK,
  UPDATEDENTALOPDOUTPERSONALHIGHRISK,
  DELETEDENTALOPDOUTPERSONALHIGHRISK,
  GETDENTALOPDOUTPERSONALPOSITIONDURINGWORK,
  CREATEDENTALOPDOUTPERSONALPOSITIONDURINGWORK,
  UPDATEDENTALOPDOUTPERSONALPOSITIONDURINGWORK,
  DELETEDENTALOPDOUTPERSONALPOSITIONDURINGWORK,
  GETDENTALOPDOUTPERSONALNATUREOFWORK,
  CREATEDENTALOPDOUTPERSONALNATUREOFWORK,
  UPDATEDENTALOPDOUTPERSONALNATUREOFWORK,
  DELETEDENTALOPDOUTPERSONALNATUREOFWORK,
  GETDENTALOPDOUTALLOPATHYMEDIHIST,
  CREATEDENTALOPDOUTALLOPATHYMEDIHIST,
  UPDATEDENTALOPDOUTALLOPATHYMEDIHIST,
  DELETEDENTALOPDOUTALLOPATHYMEDIHIST,
  GETDENTALOPDOUTAYURVEDAMEDIHIST,
  CREATEDENTALOPDOUTAYURVEDAMEDIHIST,
  UPDATEDENTALOPDOUTAYURVEDAMEDIHIST,
  DELETEDENTALOPDOUTAYURVEDAMEDIHIST,
  GETDENTALOPDOUTHOMEOPATHYMEDIHIST,
  CREATEDENTALOPDOUTHOMEOPATHYMEDIHIST,
  UPDATEDENTALOPDOUTHOMEOPATHYMEDIHIST,
  DELETEDENTALOPDOUTHOMEOPATHYMEDIHIST,
  GETDENTALOPDOUTOTHERMEDIHIST,
  CREATEDENTALOPDOUTOTHERMEDIHIST,
  UPDATEDENTALOPDOUTOTHERMEDIHIST,
  DELETEDENTALOPDOUTOTHERMEDIHIST,
  GETDENTALOPDOUTANXIETYHIST,
  CREATEDENTALOPDOUTANXIETYHIST,
  UPDATEDENTALOPDOUTANXIETYHIST,
  DELETEDENTALOPDOUTANXIETYHIST,
  GETDENTALOPDOUTDEPRESSIONHIST,
  CREATEDENTALOPDOUTDEPRESSIONHIST,
  UPDATEDENTALOPDOUTDEPRESSIONHIST,
  DELETEDENTALOPDOUTDEPRESSIONHIST,
  GETDENTALOPDOUTIRRITABILITYHIST,
  CREATEDENTALOPDOUTIRRITABILITYHIST,
  UPDATEDENTALOPDOUTIRRITABILITYHIST,
  DELETEDENTALOPDOUTIRRITABILITYHIST,
  GETDENTALOPDOUTEUPHORIAHIST,
  CREATEDENTALOPDOUTEUPHORIAHIST,
  UPDATEDENTALOPDOUTEUPHORIAHIST,
  DELETEDENTALOPDOUTEUPHORIAHIST,
  GETDENTALOPDOUTOBSESSIONHIST,
  CREATEDENTALOPDOUTOBSESSIONHIST,
  UPDATEDENTALOPDOUTOBSESSIONHIST,
  DELETEDENTALOPDOUTOBSESSIONHIST,
  GETDENTALOPDOUTNEUROSISHIST,
  CREATEDENTALOPDOUTNEUROSISHIST,
  UPDATEDENTALOPDOUTNEUROSISHIST,
  DELETEDENTALOPDOUTNEUROSISHIST,
  GETDENTALOPDOUTDEPERSONALIZATIONHIST,
  CREATEDENTALOPDOUTDEPERSONALIZATIONHIST,
  UPDATEDENTALOPDOUTDEPERSONALIZATIONHIST,
  DELETEDENTALOPDOUTDEPERSONALIZATIONHIST,
  GETDENTALOPDOUTGYNECOLOGICHIST,
  CREATEDENTALOPDOUTGYNECOLOGICHIST,
  UPDATEDENTALOPDOUTGYNECOLOGICHIST,
  DELETEDENTALOPDOUTGYNECOLOGICHIST,
  GETDENTALOPDOUTMENSTRUALCYCLE,
  CREATEDENTALOPDOUTMENSTRUALCYCLE,
  UPDATEDENTALOPDOUTMENSTRUALCYCLE,
  DELETEDENTALOPDOUTMENSTRUALCYCLE,
  GETDENTALOPDOUTOBSTETRICALHIST,
  CREATEDENTALOPDOUTOBSTETRICALHIST,
  UPDATEDENTALOPDOUTOBSTETRICALHIST,
  DELETEDENTALOPDOUTOBSTETRICALHIST,
  GETDENTALOPDOUTNATUREOFDELIVERY,
  CREATEDENTALOPDOUTNATUREOFDELIVERY,
  UPDATEDENTALOPDOUTNATUREOFDELIVERY,
  DELETEDENTALOPDOUTNATUREOFDELIVERY,
  GETDENTALOPDOUTDENTALCHART,
  CREATEDENTALOPDOUTDENTALCHART,
  UPDATEDENTALOPDOUTDENTALCHART,
  DELETEDENTALOPDOUTDENTALCHART,
  GETOPDOUTENDODONTIC,
  CREATEOPDOUTENDODONTIC,
  UPDATEOPDOUTENDODONTIC,
  DELETEOPDOUTENDODONTIC,
  GETOPDOUTLABWORK,
  CREATEOPDOUTLABWORK,
  UPDATEOPDOUTLABWORK,
  DELETEOPDOUTLABWORK,
  CREATEDENTALOPDOUTPERIOCHART,
  GETDENTALOPDOUTPERIOCHART,
  UPDATEDENTALOPDOUTPERIOCHART,
  DELETEDENTALOPDOUTPERIOCHART,
} from "../actions/types";

const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CREATEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM:
      return {
        ...state,
        dietchiefcomplaintssymptomsSaveStatus: action.payload.success,
      };

    case GETOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM:
      return {
        ...state,
        dietchiefcomplaintssymptomsList: action.payload.data,
      };

    case DELETEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM:
      return {
        ...state,
        dietchiefcomplaintssymptomsDeleteStatus: action.payload.success,
      };

    case UPDATEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM:
      return {
        ...state,
        dietchiefcomplaintssymptomsUpdateStatus: action.payload.success,
      };

    case CREATEOPDOUTDENTALASSOCIATEDSYMPTOM:
      return {
        ...state,
        dietassociatedcomplaintssymptomsSaveStatus: action.payload.success,
      };

    case GETOPDOUTDENTALASSOCIATEDSYMPTOM:
      return {
        ...state,
        dietassociatedcomplaintssymptomsList: action.payload.data,
      };

    case DELETEOPDOUTDENTALASSOCIATEDSYMPTOM:
      return {
        ...state,
        dietassociatedcomplaintssymptomsDeleteStatus: action.payload.success,
      };

    case UPDATEOPDOUTDENTALASSOCIATEDSYMPTOM:
      return {
        ...state,
        dietassociatedcomplaintssymptomsUpdateStatus: action.payload.success,
      };

    case CREATEOPDOUTDENTALPRESENTILLNESSHISTORY:
      return {
        ...state,
        dietpresentillnesshistorycomorbiditySaveStatus: action.payload.success,
      };

    case GETOPDOUTDENTALPRESENTILLNESSHISTORY:
      return {
        ...state,
        dietpresentillnesshistorycomorbidityList: action.payload.data,
      };

    case DELETEOPDOUTDENTALPRESENTILLNESSHISTORY:
      return {
        ...state,
        dietpresentillnesshistorycomorbidityDeleteStatus:
          action.payload.success,
      };

    case UPDATEOPDOUTDENTALPRESENTILLNESSHISTORY:
      return {
        ...state,
        dietpresentillnesshistorycomorbidityUpdateStatus:
          action.payload.success,
      };

    case GETDENTALCHILDHOODILLNESSES:
      return {
        ...state,
        dentalChildhoodIllnessList: action.payload.data,
      };

    case CREATEDENTALCHILDHOODILLNESSES:
      return {
        ...state,
        dentalChildhoodIllnessSaveStatus: action.payload.success,
      };

    case DELETEDENTALCHILDHOODILLNESSES:
      return {
        ...state,
        dentalChildhoodIllnessDeleteStatus: action.payload.success,
      };
    case UPDATEDENTALCHILDHOODILLNESSES:
      return {
        ...state,
        dentalChildhoodIllnessUpdateStatus: action.payload.success,
      };

    case GETDENTALADULTILLNESSES:
      return {
        ...state,
        dentalAdultIllnessList: action.payload.data,
      };

    case CREATEDENTALADULTILLNESSES:
      return {
        ...state,
        dentalAdultIllnessSaveStatus: action.payload.success,
      };
    case DELETEDENTALADULTILLNESSES:
      return {
        ...state,
        dentalAdultIllnessDeleteStatus: action.payload.success,
      };
    case UPDATEDENTALADULTILLNESSES:
      return {
        ...state,
        dentalAdultIllnessUpdateStatus: action.payload.success,
      };

    case GETDENTALHEALTHMAINTENANCE:
      return {
        ...state,
        dentalHealthMaintenanceList: action.payload.data,
      };

    case CREATEDENTALHEALTHMAINTENANCE:
      return {
        ...state,
        dentalHealthMaintenanceSaveStatus: action.payload.success,
      };

    case CREATEDENTALADULTILLNESSES:
      return {
        ...state,
        dentalAdultIllnessSaveStatus: action.payload.success,
      };

    case DELETEDENTALHEALTHMAINTENANCE:
      return {
        ...state,
        dentalHealthMaintenanceDeleteStatus: action.payload.success,
      };
    case UPDATEDENTALHEALTHMAINTENANCE:
      return {
        ...state,
        dentalHealthMaintenanceUpdateStatus: action.payload.success,
      };

    case GETDENTALSYMPTOMS:
      return {
        ...state,
        dentalSymptomsList: action.payload.data,
      };
    case CREATEDENTALSYMPTOMS:
      return {
        ...state,
        dentalSymptomsSaveStatus: action.payload.success,
      };

    case DELETEDENTALSYMPTOMS:
      return {
        ...state,
        dentalSymptomsDeleteStatus: action.payload.success,
      };
    case UPDATEDENTALSYMPTOMS:
      return {
        ...state,
        dentalSymptomsUpdateStatus: action.payload.success,
      };

    case GETDENTALCOMORBIDITY:
      return {
        ...state,
        dentalComorbidityList: action.payload.data,
      };

    case CREATEDENTALCOMORBIDITY:
      return {
        ...state,
        dentalComorbiditySaveStatus: action.payload.success,
      };

    case DELETEDENTALCOMORBIDITY:
      return {
        ...state,
        dentalComorbidityDeleteStatus: action.payload.success,
      };
    case UPDATEDENTALCOMORBIDITY:
      return {
        ...state,
        dentalComorbidityUpdateStatus: action.payload.success,
      };

    case GETDENTALPERSONALHISTORY:
      return {
        ...state,
        dentalPersonalHistoryList: action.payload.data,
      };

    case CREATEDENTALPERSONALHISTORY:
      return {
        ...state,
        dentalPersonalHistorySaveStatus: action.payload.success,
      };

    case DELETEDENTALPERSONALHISTORY:
      return {
        ...state,
        dentalPersonalHistoryDeleteStatus: action.payload.success,
      };
    case UPDATEDENTALPERSONALHISTORY:
      return {
        ...state,
        dentalPersonalHistoryUpdateStatus: action.payload.success,
      };

    case GETDENTALOCCUPATIONALHISTORY:
      return {
        ...state,
        dentalOccupationalHistoryList: action.payload.data,
      };

    case CREATEDENTALOCCUPATIONALHISTORY:
      return {
        ...state,
        dentalOccupationalHistorySaveStatus: action.payload.success,
      };

    case DELETEDENTALOCCUPATIONALHISTORY:
      return {
        ...state,
        dentalOccupationalHistoryDeleteStatus: action.payload.success,
      };
    case UPDATEDENTALOCCUPATIONALHISTORY:
      return {
        ...state,
        dentalOccupationalHistoryUpdateStatus: action.payload.success,
      };

    case CREATEDENTALPSYCHOLOGICAL:
      return {
        ...state,
        dentalPsychologicalSaveStatus: action.payload.success,
      };

    case GETDENTALPSYCHOLOGICAL:
      return { ...state, dentalPsychologicalList: action.payload.data };

    case DELETEDENTALPSYCHOLOGICAL:
      return {
        ...state,
        dentalPsychologicalDeleteStatus: action.payload.success,
      };

    case UPDATEDENTALPSYCHOLOGICAL:
      return {
        ...state,
        dentalPsychologicalUpdateStatus: action.payload.success,
      };

    case CREATEDENTALGYNECOLOGICAL:
      return {
        ...state,
        dentalGynecologicalSaveStatus: action.payload.success,
      };

    case GETDENTALGYNECOLOGICAL:
      return { ...state, dentalGynecologicalList: action.payload.data };

    case DELETEDENTALGYNECOLOGICAL:
      return {
        ...state,
        dentalGynecologicalDeleteStatus: action.payload.success,
      };

    case UPDATEDENTALGYNECOLOGICAL:
      return {
        ...state,
        dentalGynecologicalUpdateStatus: action.payload.success,
      };

    case CREATEDENTALOBSTETRICAL:
      return { ...state, dentalObstetricalSaveStatus: action.payload.success };

    case GETDENTALOBSTETRICAL:
      return { ...state, dentalObstetricalList: action.payload.data };

    case DELETEDENTALOBSTETRICAL:
      return {
        ...state,
        dentalObstetricalDeleteStatus: action.payload.success,
      };

    case UPDATEDENTALOBSTETRICAL:
      return {
        ...state,
        dentalObstetricalUpdateStatus: action.payload.success,
      };

    case CREATEGENERALOPDOBSTETRICALHISTORY:
      return {
        ...state,
        dentalopdObstetricalSaveStatus: action.payload.success,
      };

    case GETGENERALOPDOBSTETRICALHISTORY:
      return { ...state, dentalopdObstetricalList: action.payload.data };

    case DELETEGENERALOPDOBSTETRICALHISTORY:
      return {
        ...state,
        dentalopdObstetricalDeleteStatus: action.payload.success,
      };

    case UPDATEGENERALOPDOBSTETRICALHISTORY:
      return {
        ...state,
        dentalopdObstetricalUpdateStatus: action.payload.success,
      };

    case CREATEGENERALCOMPLAINTPASTILLNESSNOTE:
      return {
        ...state,
        dentalopdpastillnessnoteSaveStatus: action.payload.success,
      };

    case GETGENERALCOMPLAINTPASTILLNESSNOTE:
      return { ...state, dentalopdpastillnessnoteList: action.payload.data };

    case DELETEGENERALCOMPLAINTPASTILLNESSNOTE:
      return {
        ...state,
        dentalopdpastillnessnoteDeleteStatus: action.payload.success,
      };

    case UPDATEGENERALCOMPLAINTPASTILLNESSNOTE:
      return {
        ...state,
        dentalopdpastillnessnoteUpdateStatus: action.payload.success,
      };

    case CREATEDENTALCOMPLAINTFAMILYRELATION:
      return {
        ...state,
        dentalopdfamilyrelationSaveStatus: action.payload.success,
      };

    case GETDENTALCOMPLAINTFAMILYRELATION:
      return { ...state, dentalopdfamilyrelationList: action.payload.data };

    case DELETEDENTALCOMPLAINTFAMILYRELATION:
      return {
        ...state,
        dentalopdfamilyrelationDeleteStatus: action.payload.success,
      };

    case UPDATEDENTALCOMPLAINTFAMILYRELATION:
      return {
        ...state,
        dentalopdfamilyrelationUpdateStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTPERSONALDIETHIST:
      return { ...state, personalDietSaveStatus: action.payload.success };
    case GETDENTALOPDOUTPERSONALDIETHIST:
      return { ...state, personalDietList: action.payload.data };
    case UPDATEDENTALOPDOUTPERSONALDIETHIST:
      return { ...state, personalDietUpdateStatus: action.payload.success };
    case DELETEDENTALOPDOUTPERSONALDIETHIST:
      return { ...state, personalDietDeleteStatus: action.payload.success };

    case CREATEDENTALOPDOUTPERSONALAPPETITEHIST:
      return { ...state, personalAppetiteSaveStatus: action.payload.success };
    case GETDENTALOPDOUTPERSONALAPPETITEHIST:
      return { ...state, personalAppetiteList: action.payload.data };
    case UPDATEDENTALOPDOUTPERSONALAPPETITEHIST:
      return { ...state, personalAppetiteUpdateStatus: action.payload.success };
    case DELETEDENTALOPDOUTPERSONALAPPETITEHIST:
      return { ...state, personalAppetiteDeleteStatus: action.payload.success };
    case CREATEDENTALOPDOUTPERSONALDIGESTIVETRACTHIST:
      return {
        ...state,
        personalDigestiveTractSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTPERSONALDIGESTIVETRACTHIST:
      return { ...state, personalDigestiveTractList: action.payload.data };
    case UPDATEDENTALOPDOUTPERSONALDIGESTIVETRACTHIST:
      return {
        ...state,
        personalDigestiveTractUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTPERSONALDIGESTIVETRACTHIST:
      return {
        ...state,
        personalDigestiveTractDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTPERSONALBOWELHIST:
      return { ...state, personalBowelSaveStatus: action.payload.success };
    case GETDENTALOPDOUTPERSONALBOWELHIST:
      return { ...state, personalBowelList: action.payload.data };
    case UPDATEDENTALOPDOUTPERSONALBOWELHIST:
      return { ...state, personalBowelUpdateStatus: action.payload.success };
    case DELETEDENTALOPDOUTPERSONALBOWELHIST:
      return { ...state, personalBowelDeleteStatus: action.payload.success };

    case CREATEDENTALOPDOUTPERSONALSLEEPHIST:
      return { ...state, personalSleepSaveStatus: action.payload.success };
    case GETDENTALOPDOUTPERSONALSLEEPHIST:
      return { ...state, personalSleepList: action.payload.data };
    case UPDATEDENTALOPDOUTPERSONALSLEEPHIST:
      return { ...state, personalSleepUpdateStatus: action.payload.success };
    case DELETEDENTALOPDOUTPERSONALSLEEPHIST:
      return { ...state, personalSleepDeleteStatus: action.payload.success };

    case CREATEDENTALOPDOUTPERSONALADDICTIONS:
      return { ...state, personalAddictionsSaveStatus: action.payload.success };
    case GETDENTALOPDOUTPERSONALADDICTIONS:
      return { ...state, personalAddictionsList: action.payload.data };
    case UPDATEDENTALOPDOUTPERSONALADDICTIONS:
      return {
        ...state,
        personalAddictionsUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTPERSONALADDICTIONS:
      return {
        ...state,
        personalAddictionsDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTPERSONALHIGHRISK:
      return { ...state, personalHighRiskSaveStatus: action.payload.success };
    case GETDENTALOPDOUTPERSONALHIGHRISK:
      return { ...state, personalHighRiskList: action.payload.data };
    case UPDATEDENTALOPDOUTPERSONALHIGHRISK:
      return { ...state, personalHighRiskUpdateStatus: action.payload.success };
    case DELETEDENTALOPDOUTPERSONALHIGHRISK:
      return { ...state, personalHighRiskDeleteStatus: action.payload.success };

    case CREATEDENTALOPDOUTPERSONALPOSITIONDURINGWORK:
      return {
        ...state,
        personalPositionDuringWorkSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTPERSONALPOSITIONDURINGWORK:
      return { ...state, personalPositionDuringWorkList: action.payload.data };
    case UPDATEDENTALOPDOUTPERSONALPOSITIONDURINGWORK:
      return {
        ...state,
        personalPositionDuringWorkUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTPERSONALPOSITIONDURINGWORK:
      return {
        ...state,
        personalPositionDuringWorkDeleteStatus: action.payload.success,
      };
    case CREATEDENTALOPDOUTPERSONALNATUREOFWORK:
      return {
        ...state,
        personalNatureOfWorkSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTPERSONALNATUREOFWORK:
      return { ...state, personalNatureOfWorkList: action.payload.data };
    case UPDATEDENTALOPDOUTPERSONALNATUREOFWORK:
      return {
        ...state,
        personalNatureOfWorkUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTPERSONALNATUREOFWORK:
      return {
        ...state,
        personalNatureOfWorkDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTALLOPATHYMEDIHIST:
      return {
        ...state,
        allopathyMediHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTALLOPATHYMEDIHIST:
      return {
        ...state,
        allopathyMediHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTALLOPATHYMEDIHIST:
      return {
        ...state,
        allopathyMediHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTALLOPATHYMEDIHIST:
      return {
        ...state,
        allopathyMediHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTAYURVEDAMEDIHIST:
      return {
        ...state,
        ayurvedaMediHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTAYURVEDAMEDIHIST:
      return {
        ...state,
        ayurvedaMediHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTAYURVEDAMEDIHIST:
      return {
        ...state,
        ayurvedaMediHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTAYURVEDAMEDIHIST:
      return {
        ...state,
        ayurvedaMediHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTHOMEOPATHYMEDIHIST:
      return {
        ...state,
        homeopathyMediHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTHOMEOPATHYMEDIHIST:
      return {
        ...state,
        homeopathyMediHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTHOMEOPATHYMEDIHIST:
      return {
        ...state,
        homeopathyMediHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTHOMEOPATHYMEDIHIST:
      return {
        ...state,
        homeopathyMediHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTOTHERMEDIHIST:
      return {
        ...state,
        otherMediHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTOTHERMEDIHIST:
      return {
        ...state,
        otherMediHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTOTHERMEDIHIST:
      return {
        ...state,
        otherMediHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTOTHERMEDIHIST:
      return {
        ...state,
        otherMediHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTANXIETYHIST:
      return {
        ...state,
        anxietyHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTANXIETYHIST:
      return {
        ...state,
        anxietyHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTANXIETYHIST:
      return {
        ...state,
        anxietyHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTANXIETYHIST:
      return {
        ...state,
        anxietyHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTDEPRESSIONHIST:
      return {
        ...state,
        depressionHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTDEPRESSIONHIST:
      return {
        ...state,
        depressionHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTDEPRESSIONHIST:
      return {
        ...state,
        depressionHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTDEPRESSIONHIST:
      return {
        ...state,
        depressionHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTIRRITABILITYHIST:
      return {
        ...state,
        irritabilityHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTIRRITABILITYHIST:
      return {
        ...state,
        irritabilityHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTIRRITABILITYHIST:
      return {
        ...state,
        irritabilityHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTIRRITABILITYHIST:
      return {
        ...state,
        irritabilityHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTEUPHORIAHIST:
      return {
        ...state,
        euphoriaHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTEUPHORIAHIST:
      return {
        ...state,
        euphoriaHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTEUPHORIAHIST:
      return {
        ...state,
        euphoriaHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTEUPHORIAHIST:
      return {
        ...state,
        euphoriaHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTOBSESSIONHIST:
      return {
        ...state,
        obsessionHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTOBSESSIONHIST:
      return {
        ...state,
        obsessionHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTOBSESSIONHIST:
      return {
        ...state,
        obsessionHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTOBSESSIONHIST:
      return {
        ...state,
        obsessionHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTNEUROSISHIST:
      return {
        ...state,
        neurosisHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTNEUROSISHIST:
      return {
        ...state,
        neurosisHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTNEUROSISHIST:
      return {
        ...state,
        neurosisHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTNEUROSISHIST:
      return {
        ...state,
        neurosisHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTDEPERSONALIZATIONHIST:
      return {
        ...state,
        depersonalizationHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTDEPERSONALIZATIONHIST:
      return {
        ...state,
        depersonalizationHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTDEPERSONALIZATIONHIST:
      return {
        ...state,
        depersonalizationHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTDEPERSONALIZATIONHIST:
      return {
        ...state,
        depersonalizationHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTGYNECOLOGICHIST:
      return {
        ...state,
        gynecologicHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTGYNECOLOGICHIST:
      return {
        ...state,
        gynecologicHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTGYNECOLOGICHIST:
      return {
        ...state,
        gynecologicHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTGYNECOLOGICHIST:
      return {
        ...state,
        gynecologicHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTMENSTRUALCYCLE:
      return {
        ...state,
        menstrualCycleSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTMENSTRUALCYCLE:
      return {
        ...state,
        menstrualCycleList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTMENSTRUALCYCLE:
      return {
        ...state,
        menstrualCycleUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTMENSTRUALCYCLE:
      return {
        ...state,
        menstrualCycleDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTOBSTETRICALHIST:
      return {
        ...state,
        obstetricalHistSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTOBSTETRICALHIST:
      return {
        ...state,
        obstetricalHistList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTOBSTETRICALHIST:
      return {
        ...state,
        obstetricalHistUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTOBSTETRICALHIST:
      return {
        ...state,
        obstetricalHistDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTNATUREOFDELIVERY:
      return {
        ...state,
        natureOfDeliverySaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTNATUREOFDELIVERY:
      return {
        ...state,
        natureOfDeliveryList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTNATUREOFDELIVERY:
      return {
        ...state,
        natureOfDeliveryUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTNATUREOFDELIVERY:
      return {
        ...state,
        natureOfDeliveryDeleteStatus: action.payload.success,
      };
    case CREATEDENTALOPDOUTDENTALCHART:
      return {
        ...state,
        dentalChartSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTDENTALCHART:
      console.log("Reducer Received Data:", action.payload); // ✅ Debug Redux state
      return {
        ...state,
        dentalChartList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTDENTALCHART:
      return {
        ...state,
        dentalChartUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTDENTALCHART:
      return {
        ...state,
        dentalChartDeleteStatus: action.payload.success,
      };

    case CREATEOPDOUTENDODONTIC:
      return {
        ...state,
        dentalEndodonticSaveStatus: action.payload.success,
      };
    case GETOPDOUTENDODONTIC:
      return {
        ...state,
        dentalEndodonticList: action.payload.data,
      };
    case UPDATEOPDOUTENDODONTIC:
      return {
        ...state,
        dentalEndodonticUpdateStatus: action.payload.success,
      };
    case DELETEOPDOUTENDODONTIC:
      return {
        ...state,
        dentalEndodonticDeleteStatus: action.payload.success,
      };

    case CREATEOPDOUTLABWORK:
      return {
        ...state,
        dentalworklabSaveStatus: action.payload.success,
      };
    case GETOPDOUTLABWORK:
      return {
        ...state,
        dentalworklabList: action.payload.data,
      };
    case UPDATEOPDOUTLABWORK:
      return {
        ...state,
        dentalworklabUpdateStatus: action.payload.success,
      };
    case DELETEOPDOUTLABWORK:
      return {
        ...state,
        dentalworklabDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOPDOUTPERIOCHART:
      return {
        ...state,
        dentalperiochartSaveStatus: action.payload.success,
      };
    case GETDENTALOPDOUTPERIOCHART:
      return {
        ...state,
        dentalperiochartList: action.payload.data,
      };
    case UPDATEDENTALOPDOUTPERIOCHART:
      return {
        ...state,
        dentalperiochartUpdateStatus: action.payload.success,
      };
    case DELETEDENTALOPDOUTPERIOCHART:
      return {
        ...state,
        dentalperiochartDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
